/* =============================================================================
   Akademija Starfy - polarna poravnava
   =============================================================================
   Trije moduli. Ta stran ni okras: iskalo pola je orodje, ki ga bo nekdo
   odprl na terenu ob pol enih zjutraj, zato so tu prave koordinate in prava
   zvezdna ura, ne priblizek, ki "izgleda kot nebo".

   Kaj racunamo:

     GMST (Greenwiski zvezdni cas) iz datuma in ure, iz njega krajevni zvezdni
     cas za dano zemljepisno dolzino, iz tega pa urni kot vsake zvezde:
     H = LST - RA. Urni kot je natanko tisto, kar iskalo pola sprasuje - "kje
     na krogu naj bo Severnica nocoj ob tej uri".

     Projekcija je azimutalna ekvidistantna okoli pola: oddaljenost od sredisca
     je sorazmerna z 90 - deklinacija, smer pa je urni kot. Zato so razdalje
     med zvezdami blizu pola pravilne in vzorec Velikega voza je prepoznaven.

   Severnica NI na polu. Od njega je 0,74 stopinje in ga obkrozi v 24 urah -
   prav zato je poravnava opravilo in ne "usmeri v Severnico".
   ========================================================================== */
(function () {
  "use strict";

  var NS = "http://www.w3.org/2000/svg";
  var POLARIS = { ra: 2.530, dec: 89.264, m: 2.0, ime: "Severnica" };
  var LON = 14.5;   // Slovenija, priblizno Ljubljana

  // RA v urah, deklinacija v stopinjah, m je zvezdna velicina (za velikost pike)
  var VOZ = [
    { ra: 11.062, dec: 61.751, m: 1.8, ime: "Dubhe" },
    { ra: 11.031, dec: 56.382, m: 2.4, ime: "Merak" },
    { ra: 11.897, dec: 53.695, m: 2.4, ime: "Phecda" },
    { ra: 12.257, dec: 57.033, m: 3.3, ime: "Megrez" },
    { ra: 12.900, dec: 55.960, m: 1.8, ime: "Alioth" },
    { ra: 13.399, dec: 54.925, m: 2.2, ime: "Mizar" },
    { ra: 13.792, dec: 49.313, m: 1.9, ime: "Alkaid" }
  ];
  var KASIOPEJA = [
    { ra: 0.153, dec: 59.150, m: 2.3, ime: "Caph" },
    { ra: 0.675, dec: 56.537, m: 2.2, ime: "Schedar" },
    { ra: 0.945, dec: 60.717, m: 2.5, ime: "Gamma Cas" },
    { ra: 1.430, dec: 60.235, m: 2.7, ime: "Ruchbah" },
    { ra: 1.907, dec: 63.670, m: 3.4, ime: "Segin" }
  ];
  var KOCHAB = { ra: 14.845, dec: 74.155, m: 2.1, ime: "Kochab" };

  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  /* Julijanski dan iz datuma in ure (UT). */
  function julianDay(y, mo, d, hUT) {
    if (mo <= 2) { y -= 1; mo += 12; }
    var A = Math.floor(y / 100), B = 2 - A + Math.floor(A / 4);
    return Math.floor(365.25 * (y + 4716)) + Math.floor(30.6001 * (mo + 1)) + d + B - 1524.5 + hUT / 24;
  }

  /* Krajevni zvezdni cas v stopinjah. */
  function lstDeg(y, mo, d, hLocal, lon, poletni) {
    var hUT = hLocal - (poletni ? 2 : 1);          // Slovenija: CET/CEST
    var jd = julianDay(y, mo, d, hUT);
    var T = (jd - 2451545.0) / 36525;
    var gmst = 280.46061837 + 360.98564736629 * (jd - 2451545.0) + 0.000387933 * T * T;
    return ((gmst + lon) % 360 + 360) % 360;
  }

  /* Urni kot zvezde v stopinjah: koliko je nebo zavrtelo mimo nje. */
  function hourAngle(raHours, lst) {
    return ((lst - raHours * 15) % 360 + 360) % 360;
  }

  /* Azimutalna ekvidistantna projekcija okoli pola.
     Gledamo proti severu: zvezda z urnim kotom 0 je NAD polom, z narascajocim
     urnim kotom pa potuje proti zahodu, torej v levo - to je vrtenje v
     nasprotni smeri urinega kazalca, kot ga vidimo v resnici. */
  function project(star, lst, cx, cy, pxPerDeg) {
    var r = (90 - star.dec) * pxPerDeg;
    var h = hourAngle(star.ra, lst) * Math.PI / 180;
    return { x: cx - r * Math.sin(h), y: cy - r * Math.cos(h) };
  }

  function starR(m) { return Math.max(1.3, 4.2 - m * 0.7); }

  /* Drsnik za uro tece cez polnoc (18:00 do 30:00), ker je opazovalna noc
     ena celota. Prikazati pa je treba 02:00, ne 26:00 - in povedati, da gre
     za naslednji dan, sicer se datum in ura razideta. */
  function timeLabel(date, hour) {
    var over = hour >= 24;
    var h = hour % 24;
    var d = new Date(date.getTime());
    if (over) d.setDate(d.getDate() + 1);
    return d.toLocaleDateString("sl-SI", { day: "numeric", month: "long" }) + ", " +
      String(Math.floor(h)).padStart(2, "0") + ":" + (h % 1 ? "30" : "00");
  }

  /* =========================================================================
     1. KJE JE POL
     ========================================================================= */
  (function poleFinder() {
    var host = document.querySelector("[data-ak-pole]");
    if (!host) return;
    var svg = host.querySelector("svg");
    var inDate = host.querySelector("[data-in-date]");
    var inTime = host.querySelector("[data-in-time]");
    var outTime = host.querySelector("[data-out-time]");
    var outLst = host.querySelector("[data-out-lst]");

    var W = 560, H = 420, CX = W / 2, CY = H / 2 + 10, PPD = 5.2;
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);

    function draw() {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      el("rect", { x: 0, y: 0, width: W, height: H, fill: "#040810", rx: 12 }, svg);

      var day = +inDate.value;                 // dan v letu
      var hour = +inTime.value / 2;            // pol ure natancno
      var date = new Date(2026, 0, 1);
      date.setDate(day);
      var lst = lstDeg(2026, date.getMonth() + 1, date.getDate(), hour, LON, day > 87 && day < 303);

      outTime.textContent = timeLabel(date, hour);
      outLst.textContent = (lst / 15).toFixed(1).replace(".", ",") + " h";

      // krogi na 10, 20, 30 stopinj od pola - merilo, ne okras
      [10, 20, 30].forEach(function (d) {
        el("circle", { cx: CX, cy: CY, r: d * PPD, fill: "none", stroke: "#1b2b47", "stroke-width": "1", "stroke-dasharray": "3 5" }, svg);
        var t = el("text", { x: CX + 4, y: CY - d * PPD - 4, fill: "#3c5478", "font-size": "10" }, svg);
        t.textContent = d + "°";
      });

      var lines = el("g", { stroke: "#4a6d9e", "stroke-width": "1.3", fill: "none", opacity: ".8" }, svg);
      var stars = el("g", {}, svg);

      function drawGroup(list, closed) {
        var pts = list.map(function (s) { return project(s, lst, CX, CY, PPD); });
        var d = pts.map(function (p, i) { return (i ? "L" : "M") + p.x.toFixed(1) + " " + p.y.toFixed(1); }).join(" ");
        el("path", { d: d + (closed ? "" : "") }, lines);
        pts.forEach(function (p, i) {
          el("circle", { cx: p.x, cy: p.y, r: starR(list[i].m), fill: "#eaf3ff" }, stars);
        });
        return pts;
      }

      var vozPts = drawGroup(VOZ);
      drawGroup(KASIOPEJA);

      // kazalca: Merak -> Dubhe, podaljsano petkrat, pade na Severnico.
      // To je edini nacin, kako pol najdes brez aplikacije.
      var merak = vozPts[1], dubhe = vozPts[0];
      var dx = dubhe.x - merak.x, dy = dubhe.y - merak.y;
      el("line", { x1: merak.x, y1: merak.y, x2: merak.x + dx * 5.4, y2: merak.y + dy * 5.4,
        stroke: "#ffd08a", "stroke-width": "1.4", "stroke-dasharray": "5 5", opacity: ".85" }, svg);

      var kp = project(KOCHAB, lst, CX, CY, PPD);
      el("circle", { cx: kp.x, cy: kp.y, r: starR(KOCHAB.m), fill: "#eaf3ff" }, svg);

      // Severnica in pol
      var pp = project(POLARIS, lst, CX, CY, PPD);
      el("circle", { cx: CX, cy: CY, r: (90 - POLARIS.dec) * PPD, fill: "none", stroke: "#2f4a70", "stroke-width": "1" }, svg);
      el("circle", { cx: CX, cy: CY, r: 3, fill: "none", stroke: "#ff8a7a", "stroke-width": "1.6" }, svg);
      el("line", { x1: CX - 8, y1: CY, x2: CX + 8, y2: CY, stroke: "#ff8a7a", "stroke-width": "1" }, svg);
      el("line", { x1: CX, y1: CY - 8, x2: CX, y2: CY + 8, stroke: "#ff8a7a", "stroke-width": "1" }, svg);
      el("circle", { cx: pp.x, cy: pp.y, r: 4, fill: "#ffe9a8" }, svg);

      var lbl = el("text", { x: pp.x + 10, y: pp.y + 4, fill: "#ffe9a8", "font-size": "12", "font-weight": "600" }, svg);
      lbl.textContent = "Severnica";
      var lbl2 = el("text", { x: CX + 12, y: CY + 22, fill: "#ff8a7a", "font-size": "11" }, svg);
      lbl2.textContent = "pravi pol";
      var lbl3 = el("text", { x: 14, y: 22, fill: "#9fb0c9", "font-size": "11" }, svg);
      lbl3.textContent = "pogled proti severu · zahod je levo";
    }

    inDate.addEventListener("input", draw);
    inTime.addEventListener("input", draw);
    draw();
  })();

  /* =========================================================================
     2. POGLED SKOZI ISKALO POLA
     ========================================================================= */
  (function polarScope() {
    var host = document.querySelector("[data-ak-scope]");
    if (!host) return;
    var svg = host.querySelector("svg");
    var inDate = host.querySelector("[data-in-date]");
    var inTime = host.querySelector("[data-in-time]");
    var outWhen = host.querySelector("[data-out-when]");
    var outPos = host.querySelector("[data-out-pos]");

    var W = 420, H = 420, CX = W / 2, CY = H / 2, R = 150;
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);

    function draw() {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      el("rect", { x: 0, y: 0, width: W, height: H, fill: "#040810", rx: 12 }, svg);

      var day = +inDate.value, hour = +inTime.value / 2;
      var date = new Date(2026, 0, 1); date.setDate(day);
      var lst = lstDeg(2026, date.getMonth() + 1, date.getDate(), hour, LON, day > 87 && day < 303);
      var h = hourAngle(POLARIS.ra, lst);

      outWhen.textContent = timeLabel(date, hour);

      // vidno polje iskala, obicajno okoli 5 stopinj
      el("circle", { cx: CX, cy: CY, r: R, fill: "#060d1a", stroke: "#2b4368", "stroke-width": "2" }, svg);
      el("line", { x1: CX - R, y1: CY, x2: CX + R, y2: CY, stroke: "#1f3252", "stroke-width": "1" }, svg);
      el("line", { x1: CX, y1: CY - R, x2: CX, y2: CY + R, stroke: "#1f3252", "stroke-width": "1" }, svg);

      // krogec, po katerem Severnica kroži okoli pola
      var ringR = R * (0.736 / 2.5);
      el("circle", { cx: CX, cy: CY, r: ringR, fill: "none", stroke: "#4a6d9e", "stroke-width": "1.4" }, svg);

      // urni razdelki - iskala jih imajo, ker so edini nacin, da si pravilno
      for (var i = 0; i < 24; i++) {
        var a = i * 15 * Math.PI / 180;
        var r1 = ringR - 5, r2 = ringR + (i % 6 === 0 ? 10 : 5);
        el("line", { x1: CX - Math.sin(a) * r1, y1: CY - Math.cos(a) * r1,
          x2: CX - Math.sin(a) * r2, y2: CY - Math.cos(a) * r2,
          stroke: i % 6 === 0 ? "#7fb6ff" : "#33507d", "stroke-width": i % 6 === 0 ? "1.6" : "1" }, svg);
      }

      // pravi pol na sredini
      el("circle", { cx: CX, cy: CY, r: 3, fill: "none", stroke: "#ff8a7a", "stroke-width": "1.6" }, svg);

      // kam nocoj postaviti Severnico
      var a = h * Math.PI / 180;
      var px = CX - Math.sin(a) * ringR, py = CY - Math.cos(a) * ringR;
      el("circle", { cx: px, cy: py, r: 14, fill: "none", stroke: "#ffd08a", "stroke-width": "2", "stroke-dasharray": "4 4" }, svg);
      el("circle", { cx: px, cy: py, r: 4.5, fill: "#ffe9a8" }, svg);
      var t = el("text", { x: px, y: py - 22, "text-anchor": "middle", fill: "#ffe9a8", "font-size": "12", "font-weight": "600" }, svg);
      t.textContent = "sem";

      // Stevilcenje na ciferblatu se med izdelovalci razlikuje, marsikatero
      // iskalo sliko se obrne. Smer glede na sredino je edino, kar drzi na
      // vsakem modelu - in je natanko tisto, kar bralec vidi narisano.
      var dirs = ["navzgor", "zgoraj levo", "levo", "spodaj levo", "navzdol", "spodaj desno", "desno", "zgoraj desno"];
      var dir = dirs[Math.round(h / 45) % 8];
      outPos.textContent = dir + " od sredine · urni kot " + h.toFixed(0) + "°";

      var note = el("text", { x: CX, y: H - 14, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "11" }, svg);
      note.textContent = "polje iskala ≈ 5°";
    }

    inDate.addEventListener("input", draw);
    inTime.addEventListener("input", draw);
    draw();
  })();

  /* =========================================================================
     3. KOLIKO NATANCNO JE DOVOLJ
     ========================================================================= */
  (function accuracy() {
    var host = document.querySelector("[data-ak-accuracy]");
    if (!host) return;
    var svg = host.querySelector("svg");
    var inErr = host.querySelector("[data-in-err]");
    var inExpo = host.querySelector("[data-in-expo]");
    var outErr = host.querySelector("[data-out-err]");
    var outExpo = host.querySelector("[data-out-expo]");
    var outDrift = host.querySelector("[data-out-drift]");
    var verdict = host.querySelector("[data-out-verdict]");

    var W = 480, H = 260;
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);

    function draw() {
      var errMin = +inErr.value;             // napaka poravnave v kotnih minutah
      var sec = +inExpo.value;
      outErr.textContent = errMin < 60 ? errMin + "'" : (errMin / 60).toFixed(1).replace(".", ",") + "°";
      outExpo.textContent = sec < 60 ? sec + " s" : (sec / 60).toFixed(1).replace(".", ",") + " min";

      // Zdrs zaradi napake poravnave: pri napaki eps (radiani) se zvezda v
      // casu t premakne priblizno eps * omega * t, kjer je omega vrtenje
      // Zemlje, 15,04 kotne sekunde na sekundo.
      var eps = (errMin / 60) * Math.PI / 180;
      // Napaka v radianih krat hitrost vrtenja Zemlje (15,04 kotne sekunde na
      // sekundo) krat cas = zdrs v kotnih sekundah.
      var drift = eps * 15.04 * sec;
      outDrift.textContent = drift.toFixed(1).replace(".", ",") + "″";

      while (svg.firstChild) svg.removeChild(svg.firstChild);
      el("rect", { x: 0, y: 0, width: W, height: H, fill: "#040810", rx: 12 }, svg);

      // 2 kotni sekundi na piksel je tipicno merilo zacetniske postave
      var pxPerArcsec = 3.2;
      var len = Math.min(220, drift * pxPerArcsec / 2);
      for (var i = 0; i < 22; i++) {
        var x = 50 + (i % 6) * 72 + ((i / 6 | 0) % 2) * 30;
        var y = 44 + ((i / 6) | 0) * 52;
        if (len < 2) el("circle", { cx: x, cy: y, r: 2.4, fill: "#eaf3ff" }, svg);
        else el("line", { x1: x - len / 2, y1: y, x2: x + len / 2, y2: y, stroke: "#eaf3ff",
          "stroke-width": "3.6", "stroke-linecap": "round" }, svg);
      }
      var lbl = el("text", { x: W / 2, y: H - 12, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "11" }, svg);
      lbl.textContent = "kako izgledajo zvezde na posnetku";

      verdict.classList.remove("is-ok", "is-warn", "is-bad");
      if (drift < 2) { verdict.classList.add("is-ok"); verdict.textContent = "Zvezde ostanejo točke. Ta poravnava zdrži to ekspozicijo."; }
      else if (drift < 6) { verdict.classList.add("is-warn"); verdict.textContent = "Rahlo podolgovate. Na majhnem posnetku še mine, pri obrezu se pozna."; }
      else { verdict.classList.add("is-bad"); verdict.textContent = "Črtice. Ali skrajšajte ekspozicijo ali poravnajte natančneje - vmesne poti ni."; }
    }

    inErr.addEventListener("input", draw);
    inExpo.addEventListener("input", draw);
    draw();
  })();
})();
